import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'
import storeConfigs from 'constants/storeConfigs.ts'

export const useLiaStore = defineStore(
	storeConfigs.lia.name,
	() => {
		const user = ref<Api.WhoAmI>()
		const person = ref<Api.Person>()
		const authenticated_user = ref<Api.WhoAmI>()

		function $reset() {
			user.value = undefined
			person.value = undefined
			authenticated_user.value = undefined
		}
		return {
			authenticated_user,
			user,
			person,
			$reset,
		}
	},
	{
		persist: storeConfigs.lia.persistAll,
	}
)

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useLiaStore, import.meta.hot))
}
